export const platforms = {
    android: "Android",
    ios: "IOS",
}
